export const ENTERPRISE_PLAN_CODE = "ENTERPRISE";
